import React from 'react';

const nikoBadge = (
    <i key="niko" className="u-icon u-icon--sml u-icon--niko-facility u-mar--left--tny" style={{ flex: "0 0 auto" }}></i>
);

export const nikoFacilityItemRender = (li, itemProps) => {
    const facility = itemProps && itemProps.dataItem;
    if (!facility || !facility.isNiko) {
        return li;
    }

    const itemChildren = (
        <span style={{ display: "flex", alignItems: "center", width: "100%" }}>
            <span style={{ flex: "1" }}>{li.props.children}</span>
            {nikoBadge}
        </span>
    );

    return React.cloneElement(li, li.props, itemChildren);
};

export const nikoFacilityValueRender = (element, value) => {
    if (!value || !value.isNiko) {
        return element;
    }

    return React.cloneElement(element, element.props, [
        <span key="text">{element.props.children}</span>,
        nikoBadge,
    ]);
};
